import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIconBlue from "../img/svg/close_blue_new_design.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function NotificationPopup({ isOpen, setIsOpen, bodyTopText, headerTextBottom, bodyText, btnText }) {
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        p: 0,
        // maxWidth: "320px"
      }}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <Box>
        <Box>
          <DialogTitle
            sx={{
              m: 0,
              p: 2,
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              gap: "5px",
              textAlign: "center",
            }}
            id="customized-dialog-title"
          >
            <img src={CloseIconBlue} alt="close" onClick={() => handleClose()} style={{ marginTop: "6px" }} />
          </DialogTitle>
        </Box>
        <DialogContent
          sx={{
            direction: "rtl",
            display: "flex",
            flexDirection: "column",
            // gap: "40px",
          }}
        >
          <Typography
            sx={{
              lineHeight: "24px",
              fontSize: "16px",
              m: 0,
              color: "var(--red-text-color)",
              fontFamily: `var(--font-family) !important`,
              textAlign: "right",
              maxWidth: "256px",
              fontWeight: 700,
              mt: "49px",
            }}
          >
            {bodyTopText}
          </Typography>
          <Typography
            gutterBottom
            sx={{
              lineHeight: "24px",
              fontSize: "16px",
              m: 0,
              fontFamily: `var(--font-family) !important`,
              textAlign: "right",
              maxWidth: "265px",
              mb: "59px",
              fontWeight: 700,
              color: "var(--red-text-color)",
            }}
          >
            {bodyText}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 0, m: "0px" }}>
          <Button
            variant="contained"
            className="phone-dialog-btn phone-dialog-darkblue-btn w-100-percents"
            onClick={() => handleClose()}
            sx={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {btnText}
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
}
